export default {
  emotionReview: [],
  emotionControl: 0,
  likeReview: [],
  likeControl: 0,
  csatReview: [],
  csatControl: 0,
  likertReview: [],
  likertControl: 0,
  reviewsReview: [],
  reviewsControl: 0,
};



// WEBPACK FOOTER //
// ./src/store/modules/research/initialState.js